  const API_BASE_URL = window.axTyresCatalog?.apiUrl || '';
  const API_KEY = window.axTyresCatalog?.apiKey || '';

// Récupération du code adhérent depuis les variables injectées par WordPress
const getAdherentCode = () => {
  return window.axTyresCatalog?.adherentCode || '';
};

class TyreService {
  static async getFilters(params = {}) {
    try {
      const adherentCode = getAdherentCode();
      const queryParams = new URLSearchParams({
        ...params,
        ...(adherentCode ? { adherentCode } : {})
      }).toString();
      
      const url = `${API_BASE_URL}/tyre/filter${queryParams ? `?${queryParams}` : ''}`;
      
      const response = await fetch(url, {
        headers: {
          'X-API-KEY': API_KEY,
        },
      });
      
      if (!response.ok) {
        throw new Error('Erreur lors de la récupération des filtres');
      }
      
      const data = await response.json();
      
      // Si on a un code adhérent mais que les brands sont vides,
      // on refait un appel sans code adhérent pour récupérer tous les filtres
      if (adherentCode && (!data.brands || data.brands.length === 0)) {
        console.log('Aucun filtre disponible avec le code adhérent, récupération des filtres globaux...');
        
        const fallbackQueryParams = new URLSearchParams(params).toString();
        const fallbackUrl = `${API_BASE_URL}/tyre/filter${fallbackQueryParams ? `?${fallbackQueryParams}` : ''}`;
        
        const fallbackResponse = await fetch(fallbackUrl, {
          headers: {
            'X-API-KEY': API_KEY,
          },
        });
        
        if (fallbackResponse.ok) {
          const fallbackData = await fallbackResponse.json();
          // Indiquer qu'on est en mode fallback (sans code adhérent)
          fallbackData.isFallbackMode = true;
          return fallbackData;
        }
      }
      
      return data;
    } catch (error) {
      console.error('Erreur API:', error);
      throw error;
    }
  }

  static async searchTyres(params) {
    try {
      const queryParams = new URLSearchParams({
        ...params,
        adherentCode: getAdherentCode()
      }).toString();
      
      const response = await fetch(`${API_BASE_URL}/tyre/result?${queryParams}`, {
        headers: {
          'X-API-KEY': API_KEY,
        },
      });
      
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || 'Erreur lors de la recherche des pneus');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Erreur API:', error);
      throw error;
    }
  }

  static async getSegments(params = {}) {
    try {
      const { brand, ...otherParams } = params;
      
      const queryParams = new URLSearchParams({
        ...otherParams,
        adherentCode: getAdherentCode()
      }).toString();
      
      const response = await fetch(`${API_BASE_URL}/tyre/segment?${queryParams}`, {
        headers: {
          'X-API-KEY': API_KEY,
        },
      });
      
      if (!response.ok) {
        throw new Error('Erreur lors de la récupération des segments');
      }
      
      return await response.json();
    } catch (error) {
      console.error('Erreur API:', error);
      throw error;
    }
  }
}

export default TyreService; 